import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "src/app/providers/navigation.service";
import { AddTrackingItemsComponent } from "../new-v2-component/add-tracking-items/add-tracking-items.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { formatDate } from "@angular/common";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";

@Component({
  selector: "sm-tracking-items",
  templateUrl: "./tracking-items.component.html",
  styleUrls: ["./tracking-items.component.scss"],
})
export class TrackingItemsComponent implements OnInit, OnDestroy {
  progressTrackersData: any = [];
    employeeHash: any = localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
  loader: boolean = false;
  apisub: Subscription;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ns: NavigationService,
    private dialog: MatDialog,
    private apiservice: ApiService,
    private ls: LoaderServiceService
  ) {
    this.ns.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_PROGRESS_TRACKERS_FOR_MEMBER
      ) {
        this.progressTrackersData = [];
        if (resdata.result) {
          this.progressTrackersData = resdata.result;
          this.progressTrackersData.forEach((element: any) => {
            element.tracking_logs =
              typeof element.tracking_logs == "string"
                ? JSON.parse(element.tracking_logs)
                : element.tracking_logs;

            if (element.tracking_logs) {
              // create a sorted copy of logs (oldest first)
              const sortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(a.creation_time).getTime() -
                  new Date(b.creation_time).getTime()
              );
              const reversersortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(b.creation_time).getTime() -
                new Date(a.creation_time).getTime()
              );
                            element.sortedLogs = reversersortedLogs 


              console.log("sorted::::>>>>", sortedLogs);

              element.graphData = {
                datasets: [
                  {
                    label: element.tracking_item_name,
                    data: sortedLogs.map((item: any) =>
                      Number(item.tracking_item_value)
                    ),

                    borderColor: "#FFC107",
                    fill: false,
                    lineTension: 0,
                  },
                ],
                labels: sortedLogs.map((item: any) =>
                  this.formatDateToReadable(item.creation_time)
                ),
              };
            }
          });
        }

        this.ls.showLoader = false;
        this.loader = false;
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_TRACKER
      ) {
        if (resdata.result) {
    this.apiservice.getProgressTrackersForMember(this.memberHash);
        }
      }
    });
  }
formatDateToReadable(dateString: string): string {
  if (!dateString) return "Invalid Date";

  // Convert "YYYY-MM-DD HH:mm:ss.SSSSSS" -> "YYYY-MM-DDTHH:mm:ss.SSSSSS"
  const normalized = dateString.replace(' ', 'T');

  const parsedDate = new Date(normalized);

  if (isNaN(parsedDate.getTime())) {
    console.error(`Invalid date format: ${dateString}`);
    return "Invalid Date";
  }

  return formatDate(parsedDate, 'dd MMM', 'en-US');
}



  memberHash: any = "";
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.memberHash = data.memberHash;
      }
    });

    this.loader = true;
    this.ls.showLoader = true;
    this.apiservice.getProgressTrackersForMember(this.memberHash);
  }

  opentrackdetails(item: any) {
    if(item.tracking_enabled == 1){
      console.log(item);
  
      const toStore = {
      hash_id: item.hash_id,
      creator_type: item.creator_type,
      created_by: item.created_by,
      tracking_item_name: item.tracking_item_name
    };
      
      sessionStorage.setItem("ciot", JSON.stringify(toStore));
      this.router.navigate(["tracking-item-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          trackerName: item.tracking_item_name,
          trackerHash: item.hash_id,
        },
      });

    }
  }

  addtrackingitem() {
    let dialogref = this.dialog.open(AddTrackingItemsComponent, {
      width: "400px",
      disableClose: true,
      data: {
        memberHash: this.memberHash,
      },
    });

    dialogref.afterClosed().subscribe((data) => {
      if (data) {
        this.apiservice.getProgressTrackersForMember(this.memberHash);
      }
    });
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  deleteItem(item:any){
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
         // width: "400px",
         data: {
           title: "Alert",
           message: "Are you sure you want to delete this data?",
           okbtn: "Yes",
           cancelbtn: "No",
           type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
         },
         disableClose: true,
       });
       dialogRef.afterClosed().subscribe((result) => {
         console.log(result);
         if (result) {
           let obj = {
             hash_id: item.hash_id,
             member_hash: this.memberHash,
             status: 0,
             creation_time: this.formatDateString1(new Date()),
             creator_type: 2,
             created_by: localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID),
           };
   
           this.ls.showLoader = true;
           this.apiservice.addEditProgressTracker(obj);
         }
       }); 
  }


  formatDateString1(datestr: Date): string {
    const now = new Date(datestr);

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
